import { platform } from "~/lib/platform";

export type NativeMediaSource = "camera" | "photos";

interface PickedMediaMeta {
  token: string;
  filename: string;
  contentType: string;
  len: number;
}

export async function pickMobileMedia(source: NativeMediaSource): Promise<File | null> {
  if (platform !== "tauri") return null;
  const { invoke } = await import("@tauri-apps/api/core");
  const command = source === "camera" ? "native_pick_camera_media" : "native_pick_photo_media";
  const meta = await invoke<PickedMediaMeta>(command);
  if (meta.len === 0) return null;
  const bytes = await invoke<ArrayBuffer>("native_read_picked_media", { token: meta.token });
  const type = meta.contentType || "application/octet-stream";
  return new File([bytes], meta.filename || defaultFilename(source, type), { type });
}

function defaultFilename(source: NativeMediaSource, contentType: string): string {
  const ext = contentType === "image/png" ? "png" : "jpg";
  return source === "camera" ? `camera.${ext}` : `photo.${ext}`;
}

export function mediaPickerErrorMessage(source: NativeMediaSource, err: unknown): string {
  const message = err instanceof Error ? err.message : String(err);
  if (/permission|denied|unauthori[sz]ed/i.test(message)) {
    return source === "camera"
      ? "Camera access was denied. Enable it in Settings and try again."
      : "Photo access was denied. Enable it in Settings and try again.";
  }
  return "Could not open the picker. Try again.";
}
